<template>
  <v-select v-model="current" label="name" :options="companies" class="w-full"></v-select>
</template>

<script>
export default {
  name: "ht-company-select",
  data() {
    return {
      companies: null,
      current: null
    };
  },
  computed: {},

  mounted() {
    this.current = JSON.parse(localStorage.getItem("company-selected"));
  },

  created() {
    this.companies = JSON.parse(localStorage.getItem("user"))['companies'];

    // this.current = this.companies[0];
    if (localStorage.getItem("company-selected") == null) {
      localStorage.setItem(
        "company-selected",
        JSON.stringify(this.companies[0])
      );
      //   this.current = this.companies[0];
    } else {
        this.current = JSON.parse(localStorage.getItem("company-selected"));
      console.log("loaded " + this.current);
    }
  },

  methods: {
    getCompanies() {
      return this.companies;
    }
  },

  watch: {
    current: function() {
      this.$events.fire("company-selected", this.current);

      if(this.current.slug !== this.$route.params.slug) {
        this.$router.replace({name: this.$route.name, params: {slug: this.current.slug}});
      }

      localStorage.setItem("company-selected", JSON.stringify(this.current));
    }
  }
};
</script>
